import { TemplateKey } from "PFApp/constants/templates";
import { Modal } from "PFComponents/modal";
import { useTranslation } from "react-i18next";

type PublishConfirmModalProps = {
  templateKey: TemplateKey;
  onOk: () => void;
  onClose: () => void;
};

export const PublishConfirmModal = ({ templateKey, onOk, onClose }: PublishConfirmModalProps) => {
  const { t } = useTranslation("activities");
  return (
    <Modal title={t("form.modals.noRequirements")} onOK={onOk} onClose={onClose}>
      {t("form.modals.creatingNoRequirementsWarning", { templateName: t(`templates.${templateKey}`) })}
    </Modal>
  );
};
